module.exports = __webpack_public_path__ + "media/images/application/template/logos/acclaim-accreditation-logo-be32e836f19848878a19094ea560302b.png";